(function autoCloseDetails() {
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Node)) return;

      const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
      if (!openDetails.length) return;

      const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';

      for (const detailsElement of openDetails) {
        if (!detailsElement.getAttribute('data-auto-close-details')?.includes(closingOn)) continue;
        if (detailsElement.contains(event.target)) continue;
        detailsElement.removeAttribute('open');
      }
    },
    { passive: true }
  );
})();
